import { FormControlLabel, Radio, RadioGroup } from "@mui/material"

import "./style.scss"

const UserRank = ({ value, label, onChange }: { value: string; label: string; onChange: (rank: string) => void }) => (
  <RadioGroup
    row
    aria-label={`Ранг: ${label}`}
    value={value}
    onChange={(_, rank) => onChange(rank)}
    className="rank-options"
  >
    {["5", "4", "3", "2", "1", "gk", "?"].map((rank) => (
      <FormControlLabel
        key={rank}
        value={rank}
        control={<Radio size="small" />}
        label={rank === "gk" ? "GK 🧤" : rank}
      />
    ))}
  </RadioGroup>
)
export default UserRank
